<app-mmx-icon *ngIf="isLoaderVisible$ | async" id="app-loader"></app-mmx-icon>

<mmx-maintenance-banner [clinicId]="(currentClinicId$ | async) ?? null"></mmx-maintenance-banner>

<router-outlet></router-outlet>
